import {
  BinaryConditionalData,
  GroupsManageContactData,
  HttpRequestData,
  JourneyNodeTypes,
  JourneySchema,
  NodeTypes,
  SendEmailData,
  SendSMSData,
  TagsManageContactData,
  UpsertContactTriggerData,
} from '@/src/modules/AutomationModuleNew/types/flowsTypes';

export const NODE_TYPES_MAP: Record<NodeTypes, string[]> = {
  trigger: ['upsertContact'],
  action: ['groupsManageContact', 'tagsManageContact', 'sendEmail', 'sendSMS', 'httpRequest'],
  conditional: ['binaryConditional'],
};

export const NODE_WIDTHS: Record<JourneyNodeTypes, number> = {
  upsertContact: 280,
  groupsManageContact: 280,
  binaryConditional: 45,
  sendEmail: 280,
  sendSMS: 280,
  tagsManageContact: 280,
  httpRequest: 280,
};

export const HORIZONTAL_SPACING = {
  binaryConditional: 100,
  normalNode: 120,
};

export const NODE_HEIGHT = {
  normalNode: 98,
  binaryConditional: 45,
};

export const VERTICAL_SPACING = {
  normalNode: 100,
  binaryConditional: 80,
};

export const SOURCE_HANDLE_YES = 'yes';
export const SOURCE_HANDLE_NO = 'no';
export const TYPE_GROUPS = 'belongsToGroups';
export const TYPE_TAGS = 'belongsToTags';
export const BELONG = 'or';
export const NOT_BELONG = 'nor';

export const TRANSLATIONS = {
  nodeTypes: {
    upsertContact: 'nodeTypes.upsertContact',
    groupsManageContact: 'nodeTypes.groupsManageContact',
    sendEmail: 'nodeTypes.sendEmail',
    binaryConditional: 'nodeTypes.binaryConditional',
    sendSMS: 'nodeTypes.sendSMS',
    tagsManageContact: 'nodeTypes.tagsManageContact',
    httpRequest: 'nodeTypes.httpRequest',
  },
};

export const initialUpsertContactNode: UpsertContactTriggerData = {
  id: 'node1',
  type: 'upsertContact',
  input: {
    contact: {
      type: 'variable',
      path: 'input',
    },
  },
  version: 1,
};

export const initialGroupsManageContactNode: GroupsManageContactData = {
  id: '',
  type: 'groupsManageContact',
  input: {
    contactId: undefined,
    addGroupIds: [],
    removeGroupIds: [],
  },
  version: 1,
};

export const initialSendEmailNode: SendEmailData = {
  id: '',
  type: 'sendEmail',
  input: {
    actionId: {
      type: 'literal',
      value: undefined,
    },
  },
};

export const initialBinaryConditionalNode: BinaryConditionalData = {
  id: '',
  type: 'binaryConditional',
  input: {
    condition: {
      operator: 'or',
      conditions: [],
    },
  },
};

export const initialSendSMSNode: SendSMSData = {
  id: '',
  type: 'sendSMS',
  input: {
    actionId: undefined,
  },
};

export const initialTagsManageContactNode: TagsManageContactData = {
  id: '',
  type: 'tagsManageContact',
  input: {
    addTagIds: [],
    removeTagIds: [],
  },
  version: 1,
};

export const initialHttpRequestNode: HttpRequestData = {
  id: '',
  type: 'httpRequest',
  input: {
    method: 'GET',
    url: '',
    headers: [],
    body: [],
  },
  version: 1,
};

export const initialCreateJourneySchema: JourneySchema = {
  nodes: [initialUpsertContactNode],
  connections: [],
  root: initialUpsertContactNode.id,
};
